import type { Jast } from '@atlaskit/jql-ast';
import { substring } from './common';

export const setPrimarySortDirection = (sortOrder: string, jast: Jast): string => {
	const jql = jast.represents;
	const orderBy = jast.query?.orderBy;
	if (typeof jql !== 'string') {
		return '';
	}

	if (!orderBy || !orderBy.fields.length) {
		return jql;
	}

	const { direction } = orderBy.fields[0];
	if (!direction && orderBy.fields.length > 1) {
		const { field } = orderBy.fields[0];
		if (!field.position) {
			return jql;
		}
		const [, end] = field.position;
		return `${substring(jql, 0, end)} ${sortOrder}${substring(jql, end)}`;
	}

	if (!direction) {
		return `${jql} ${sortOrder}`;
	}
	if (!direction.position) {
		return jql;
	}

	const [start, end] = direction.position;
	return `${substring(jql, 0, start)}${sortOrder}${substring(jql, end)}`;
};
